export class SampleMedia {
    id: string;
    name: string;
    mediaType: number;
    manufacturer: string;
    poreSizeMicrons: number;
    diameterMM: number;
    sorbentMaterial: string;
    phase: number;
    recommendedFlowRateSccm: number;
    usageNotes: string;
    isActive: boolean;
    createdByUserId: string;
    analyticalMethodIds?: string[]
}